/** Early load timing + Telegram ready() (phase 4.15). */
var t0: number =
  typeof performance !== 'undefined' && performance.timing
    ? performance.timing.navigationStart
    : window.__loadStart || Date.now();
window.__diag = { t0: t0, t1: Date.now(), t2: null, t3: null };
var t = window.Telegram && window.Telegram.WebApp;
if (t) {
  try {
    t.ready?.();
    if (window.__diag) window.__diag.t2 = Date.now();
  } catch (_) {}
}
